import React, { createContext, useContext, useState, useCallback, useRef } from "react";

const TooltipContext = createContext(null);

export function TooltipProvider({ children }) {
  const [tipState, setTipState] = useState({
    visible: false,
    x: 0,
    y: 0,
    title: "",
    content: "",
  });
  const timeoutRef = useRef(null);

  const showTooltip = useCallback((e, title, content) => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    let x = e.clientX + 14;
    let y = e.clientY + 14;
    if (x + 260 > window.innerWidth) x = e.clientX - 260;
    if (y + 90 > window.innerHeight) y = e.clientY - 80;

    setTipState({
      visible: true,
      x: Math.max(10, x),
      y: Math.max(10, y),
      title,
      content,
    });
  }, []);

  const moveTooltip = useCallback((e) => {
    let x = e.clientX + 14;
    let y = e.clientY + 14;
    if (x + 260 > window.innerWidth) x = e.clientX - 260;
    if (y + 90 > window.innerHeight) y = e.clientY - 80;

    setTipState((prev) => ({
      ...prev,
      x: Math.max(10, x),
      y: Math.max(10, y),
    }));
  }, []);

  const hideTooltip = useCallback(() => {
    timeoutRef.current = setTimeout(() => {
      setTipState((prev) => ({ ...prev, visible: false }));
    }, 40);
  }, []);

  return (
    <TooltipContext.Provider value={{ showTooltip, moveTooltip, hideTooltip }}>
      {children}
      {tipState.visible && (
        <div
          className="dashboard-tooltip"
          id="tip"
          style={{
            left: `${tipState.x}px`,
            top: `${tipState.y}px`,
            opacity: tipState.visible ? 1 : 0,
          }}
        >
          {tipState.title && (
            <div style={{ fontWeight: 700, color: "#60a5fa", marginBottom: "3px" }}>
              {tipState.title}
            </div>
          )}
          <div style={{ lineHeight: 1.45 }}>{tipState.content}</div>
        </div>
      )}
    </TooltipContext.Provider>
  );
}

export function useDashboardTooltip() {
  const ctx = useContext(TooltipContext);
  if (!ctx) {
    return {
      showTooltip: () => {},
      moveTooltip: () => {},
      hideTooltip: () => {},
    };
  }
  return ctx;
}

export default TooltipProvider;
